module.exports = __webpack_public_path__ + "static/media/bttw1.eec2938a.jpg";